import React from 'react';

const PastEvents = ({ event }) => {
  const { src, heading } = event;
  return (
    <div>
      <div className='img-events'>
        <img src={src} alt='' width='100%' height='100%' />
      </div>
      <h2 className='text-light'>{heading}</h2>
    </div>
  );
};

export default PastEvents;
